<div class="flex justify-between items-center">
  <span class="body-md text-content-text-body-secondary">Kontrastmodus</span>
  <core-toggle-button [formControl]="contrastModeFormControl"></core-toggle-button>
</div>
